import mainClasses from "pages/agent-chat-ticket/AgentChatTicket.module.css";
import { memo } from "react";
import { useSelector } from "react-redux";

const ChatList = () => {
  const agentChatStatus = useSelector(
    (state) => state.ringmeOttSdk.agentChatStatus
  );

  return (
    <div className="onecx-chat-sdk-root">
      {agentChatStatus !== "service" && (
        <div className={mainClasses.chatOfflineWrapper}>
          <span className={mainClasses.chatOfflineIcon}>
            <i className="fal fa-comment-times"></i>
          </span>
          <div>Hệ thống Chat đang tạm dừng</div>
        </div>
      )}

      <div className="ringme-ott-sdk-container">
        <div className="ringme-ott-sdk-root">
          <ott-sdk-root></ott-sdk-root>
        </div>
      </div>
    </div>
  );
};

export default memo(ChatList);
